export default __webpack_public_path__ + "static/media/nova-logo.d1b97c17.png";